import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import { ModalController, ToastController, LoadingController, AlertController } from '@ionic/angular';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';

import { VendPage } from '../vend/vend.page';
import { SendPage } from '../send/send.page';
import { ApiService } from '../../services/api/api.service';
import { PrintService } from '../../services/print/print.service';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { GlobalVariables } from '../../common/global-variables';
import { StorageService } from "../../services/storage/storage.service";

@Component({
  selector: 'app-validate',
  templateUrl: './validate.page.html',
  styleUrls: ['./validate.page.scss'],
})
export class ValidatePage implements OnInit {
  @Input() meterNumber: string;
  @Input() isValidateRequest: boolean;

  vendorSettings: any;
  deviceInfo: any;
  storageSettings:any;


  data: any;
  recentTransactions: any;
  recentTokens = false;
  receipt: any;
  payload: any;
  loaderToShow: any;

  constructor(private modalController: ModalController,
              public api: ApiService, public loadingController: LoadingController,
              public toastController: ToastController, private ga: GoogleAnalytics,
              public authService: AuthenticationService, private sanitizer: DomSanitizer,
              public alertController: AlertController, public printService: PrintService,
              private globals: GlobalVariables, private storageService:StorageService) { }

  ngOnInit() {
    this.deviceInfo = this.globals.deviceInfo;
    this.vendorSettings = this.globals.vendorSettings;
    this.storageSettings = this.storageService.getObject('vendor-settings');
    // construct payload object
    this.payload = {
           IMEI: this.deviceInfo.IMEI,
           MeterNumber: this.meterNumber, // '24140006743'
           Amount: 0,
           AuthToken: this.globals.userInfo.token,
           /*
            Set to false for testing 
            IsRealTransaction: false,
           */ 
            IsRealTransaction:true,
           Language: this.deviceInfo.language
          };

    this.validateMeter();

    this.ga.trackView('validate')
        .then(() => {})
        .catch(e => console.log(e));
  }

  validateMeter() {
    this.authService.startSessionTimer(true);
    this.showLoader('Looking up customer details');
    // this.ga.trackEvent('validate', 'validate-meter', this.meterNumber, this.vendAmount);

    const endpoint = this.globals.deviceInfo.remoteServer + 'validate';
    this.api.postApiEndpoint(endpoint, this.payload).subscribe((resp) => {
      if (resp.ok) {
        this.data = this.sanitizer.bypassSecurityTrustHtml(resp.data);
        this.hideLoader();
      } else {
        // this.ga.trackException('Meter Not Found: Please check the meter number', false);
        this.data = resp.msg;
        this.presentToast('Meter Not Found: Please check the meter number', 'danger');
        setTimeout(() => {
          this.hideLoader();
          this.closeModal();
        }, 2500);
      }
    });
  }

  async vendToken() {
    this.authService.startSessionTimer(true);
    // Open the vend page
    const modal = await this.modalController.create({
      component: VendPage,
      componentProps: {
        payload: this.payload
      }
    });

    modal.onDidDismiss().then((dataReturned) => {
      console.log('Vend Sent Data: ', dataReturned);
      if (!dataReturned.data.ok) {
        // print error message
        // this.data = this.sanitizer.bypassSecurityTrustHtml(dataReturned.data.msg);
      }
    });

    return await modal.present();

  }

  printLastToken() {
    debugger;
    this.authService.startSessionTimer(true);
    // this.ga.trackEvent('validate', 'reprint-last-token', this.meterNumber, this.vendAmount);
    this.showLoader('Looking up for the last Token issued for this meter ...');

    let printerValue = this.storageSettings.__zone_symbol__value.printerInterface;
    if(printerValue == 'DESKTOP'){
      //this.payload.OutputFormat = 0;
      this.payload.OutputFormat = 6;
    }else{
      this.payload.OutputFormat = 3;
    }

    const endpoint = this.globals.deviceInfo.remoteServer + 'lasttoken';
    this.api.postApiEndpoint(endpoint, this.payload).subscribe((resp) => {
      // console.log(resp);
      if (resp.ok) {
        this.receipt = resp.data;
        // console.log(resp.data);
        this.hideLoader();
        this.printService.print(resp.data);
      } else {
        this.ga.trackException(resp.msg, false);
        this.data = resp.msg;
        this.presentToast(resp.msg, 'danger');
        setTimeout(() => {
          this.hideLoader();
          this.closeModal();
        }, 4000);
      }
    });
  }

  getRecentTransactions() {
    this.authService.startSessionTimer(true);
    this.recentTokens = true;
    this.showLoader('Looking up for the recent 5 Tokens issued for this meter ...');

    const endpoint = this.globals.deviceInfo.remoteServer + 'latesttransactions';
    this.api.postApiEndpoint(endpoint, this.payload).subscribe((resp) => {
      // console.log(resp);
      if (resp.ok) {
        this.recentTransactions = resp.data;
        // console.log(resp.data);
        this.hideLoader();
      } else {
        this.ga.trackException(resp.msg, false);
        this.data = resp.msg;
        this.presentToast(resp.msg, 'danger');
        setTimeout(() => {
          this.hideLoader();
          this.closeModal();
        }, 4000);
      }
    });
  }

  retriveToken(transaction, sendToken) {
    debugger;
    let printerValue = this.storageSettings.__zone_symbol__value.printerInterface;
    if(printerValue == 'DESKTOP'){
      //this.payload.OutputFormat = 0;
      this.payload.OutputFormat = 6;
    }else{
      this.payload.OutputFormat = 3;
    }
    this.authService.startSessionTimer(true);
    this.payload.PaySeqID = transaction.PaySeqID;
    this.payload.MessageTrace = transaction.MessageTrace;
    
    // console.log(transaction);
    this.authService.checkSessionTime();
    // this.ga.trackEvent('validate', 'reprint-old-token', this.meterNumber, this.vendAmount);
    this.showLoader('Looking up for the requested Token issued for this meter ...');

    const endpoint = this.globals.deviceInfo.remoteServer + 'reprint';
    this.api.postApiEndpoint(endpoint, this.payload).subscribe((resp) => {
      // console.log(resp);
      if (resp.ok) {
        this.receipt = resp.data;
        this.hideLoader();
        if (sendToken) {
          this.sendToken(resp);
        } else {
          this.printToken(resp);
        }
      } else {
        this.ga.trackException(resp.msg, false);
        this.data = resp.msg;
        this.presentToast(resp.msg, 'danger');
        this.hideLoader();
      }
    });
  }

  async sendToken(trans) {
    this.authService.startSessionTimer(true);
    console.log(trans);
    // Open the vend page
    const modal = await this.modalController.create({
      component: SendPage,
      componentProps: {
        transaction: trans,
        vendorSettings: this.vendorSettings,
        deviceInfo: this.deviceInfo,
        payload: this.payload
      }
    });

    modal.onDidDismiss().then((dataReturned) => {
      console.log('Vend Sent Data: ', dataReturned);
      if (!dataReturned.data.ok) {
        // print error message
        // this.data = this.sanitizer.bypassSecurityTrustHtml(dataReturned.data.msg);
      }
    });

    return await modal.present();

  }

  printToken(trans) {
    this.printService.print(trans.data);
  }

  showLoader(displayMessage) {
    this.loaderToShow = this.loadingController.create({
      message: displayMessage
    }).then((res) => {
      res.present();

      res.onDidDismiss().then((dis) => {
        // console.log('Loading dismissed!');
      });
    });
    // this.hideLoader();
  }

  hideLoader() {
    setTimeout(() => {
      this.loadingController.dismiss();
    }, 500);
  }

  async closeModal() {
    const onClosedData = {
        vendorBalance: 2344,
        batchNumber: 345
    };
    await this.modalController.dismiss(onClosedData);
  }

  async presentToast(msg, color) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
      position: 'bottom',
      color
    });
    toast.present();
  }

}
